/** Date rules for the staff "Extend offer" dialog. Pure, local time: staff pick a calendar day in their own zone. */

const DEFAULT_EXTENSION_DAYS = 14

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate())

/** The expiry a picked day means: the end of that day (23:59 local), never past the server's maximum. */
export function expiryForDate(day: Date, latest: Date): Date {
  const endOfDay = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59)
  return endOfDay > latest ? latest : endOfDay
}

/** A day is selectable when its expiry would be later than both now and the current expiry, and not past the maximum. */
export function isSelectableDate(day: Date, current: Date, latest: Date, now: Date): boolean {
  if (startOfDay(day) > latest) return false
  const floor = current > now ? current : now
  return expiryForDate(day, latest) > floor
}

/** Where the picker starts: 14 days after the later of the current expiry and now, capped at the maximum. */
export function defaultDate(current: Date, now: Date, latest: Date): Date {
  const base = current > now ? current : now
  const target = new Date(base)
  target.setDate(target.getDate() + DEFAULT_EXTENSION_DAYS)
  return target > latest ? latest : target
}

/** The `YYYY/MM/DD` form `q-date` uses for its model and its `options` callback. */
export function formatDateKey(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`
}

export function parseDateKey(key: string): Date {
  const [y, m, d] = key.split('/').map(Number)
  return new Date(y, m - 1, d)
}
